import React, { useMemo } from "react";
import { Position } from "@blueprintjs/core";
import classNames from "classnames";
import InfoIconWithTooltip from "components/Tooltips/InfoIconWithTooltip";
import TextTruncate from "components/TextTruncate";
import Button from "components/Button";
import DropDownButton from "rs-components/DropDownButton";
import { isNotEmpty } from "utils/validate";
import { capitalizeFirstLetter } from "utils/string";
import { ButtonSize, ButtonStyle } from "../../components/Button";
import PlusIcon from "icons/plus.svg";
import DeleteIcon from "icons/delete.svg";
import * as styles from "./styles.module.scss";
const SectionHeader = ({ title, editable, hint, hintScrollElement, mainAction, secondaryAction, tooltipPosition, classes, notAvailable, learnMoreUrl, isHighlightModeActive, customPrefix, }) => {
    const mainActionTooltip = useMemo(() => {
        const { disabled = false, disabledTooltip, customAddMessage, max } = { ...mainAction };
        if (!disabled) {
            return isNotEmpty(customAddMessage)
                ? `${customAddMessage}`
                : `Add${typeof title === "string" ? " " + title : ""}`;
        }
        else if (isNotEmpty(disabledTooltip)) {
            return disabledTooltip;
        }
        else if (max) {
            return `Maximum number of${typeof title === "string" ? " " + title : ""} is ${max}`;
        }
        else {
            return "";
        }
    }, [mainAction, title]);
    return (React.createElement("div", { className: classNames(styles.heading, classes?.root, {
            [styles.small]: mainAction?.size === ButtonSize.Small,
            [styles.notAvailable]: notAvailable,
        }) },
        customPrefix,
        React.createElement("div", { className: classNames(styles.info, classes?.infoContainer) },
            typeof title === "string" ? (React.createElement(TextTruncate, { text: capitalizeFirstLetter(title), className: classNames(styles["info-title"], classes?.title) })) : (React.createElement("div", { className: classNames(styles["info-title"], classes?.title) }, title)),
            hint && (React.createElement(InfoIconWithTooltip, { classes: {
                    className: classNames(styles["info-icon"], classes?.infoIcon),
                    portalClassName: classNames(styles["info-portal"], classes?.infoPortal),
                }, tooltipText: hint, position: tooltipPosition, scrollElement: hintScrollElement, learnMoreUrl: learnMoreUrl }))),
        editable && !notAvailable && (React.createElement("div", { className: styles.buttons },
            secondaryAction && (React.createElement(React.Fragment, null,
                React.createElement(Button, { onClick: secondaryAction.handler, square: true, style: secondaryAction.style || ButtonStyle.Secondary, size: secondaryAction.size || ButtonSize.Normal, showTooltipIfDisabled: true, label: secondaryAction.label || React.createElement(DeleteIcon, { width: 24, height: 24, className: styles.deleteIcon }), title: secondaryAction.disabled
                        ? secondaryAction.disabledTooltip
                        : secondaryAction.title || "Delete", disabled: secondaryAction.disabled, classes: secondaryAction.className ? { root: secondaryAction.className } : undefined }),
                React.createElement("div", { className: styles.divider }))),
            !isHighlightModeActive
                ? mainAction && (React.createElement(DropDownButton, { editable: true, buttonProps: {
                        classes: mainAction.className
                            ? {
                                root: mainAction.className,
                            }
                            : undefined,
                        title: mainActionTooltip,
                        showTooltipIfDisabled: true,
                        label: mainAction.label || (React.createElement(PlusIcon, { width: 15, height: 15, className: styles.plusIcon })),
                        style: mainAction.style || ButtonStyle.Primary,
                        size: mainAction.size || ButtonSize.Normal,
                        position: Position.RIGHT,
                        onClick: mainAction.menu ? undefined : mainAction.handler,
                        disabled: mainAction.disabled,
                        square: !mainAction.label,
                    }, items: mainAction.menu }))
                : null))));
};
export default SectionHeader;
